import type { Question } from '@/components/onboarding/enhance/enhanceStep.types';
import { TextArea } from '@/components/ui/TextArea';

export interface QuestionCardProps {
  answer: string;
  index: number;
  onAnswer: (value: string) => void;
  question: Question;
}

export const QuestionCard = ({
  answer,
  index,
  onAnswer,
  question: { context, question },
}: QuestionCardProps) => (
  <div className="group rounded-lg border border-border/60 bg-background/40 p-5 transition-colors hover:border-border">
    <div className="mb-3 flex items-start gap-3">
      <span className="flex size-6 shrink-0 items-center justify-center rounded-md bg-accent/10 font-mono text-2xs lg:text-sm font-semibold text-accent">
        {index + 1}
      </span>
      <div className="min-w-0">
        <p className="text-sm/relaxed lg:text-base/relaxed leading-relaxed font-medium text-foreground">
          {question}
        </p>
        {context && (
          <p className="mt-1 text-xs/relaxed lg:text-sm/relaxed text-foreground-muted/70">
            {context}
          </p>
        )}
      </div>
    </div>
    <div className="mt-3 pl-9">
      <TextArea
        onChange={(event) => onAnswer(event.target.value)}
        placeholder="Your answer..."
        rows={2}
        value={answer}
      />
    </div>
  </div>
);
